export default {
	namespaced:true,
	actions:{
        
	},
	mutations:{
        
	},
	state:{
		imgs:[
			'https://oss.uflycloud.com/ufly_ai_vpft/SelfTest/GA/GA_8_00.png',
			'https://oss.uflycloud.com/ufly_ai_vpft/SelfTest/GA/GA_8_01.png',
			'https://oss.uflycloud.com/ufly_ai_vpft/SelfTest/GA/GA_8_02.png',
			'https://oss.uflycloud.com/ufly_ai_vpft/SelfTest/GA/GA_8_03.png',
			'https://oss.uflycloud.com/ufly_ai_vpft/SelfTest/GA/GA_8_04.png',
			'https://oss.uflycloud.com/ufly_ai_vpft/SelfTest/GA/GA_8_05.png',
			'https://oss.uflycloud.com/ufly_ai_vpft/SelfTest/GA/GA_8_06.png',
			'https://oss.uflycloud.com/ufly_ai_vpft/SelfTest/GA/GA_8_07.png',
			'https://oss.uflycloud.com/ufly_ai_vpft/SelfTest/GA/GA_8_08.png',
			'https://oss.uflycloud.com/ufly_ai_vpft/SelfTest/GA/GA_8_09.png',
			'https://oss.uflycloud.com/ufly_ai_vpft/SelfTest/GA/GA_8_10.png',
			'https://oss.uflycloud.com/ufly_ai_vpft/SelfTest/GA/GA_8_11.png',
			'https://oss.uflycloud.com/ufly_ai_vpft/SelfTest/GA/GA_8_12.png',
			'https://oss.uflycloud.com/ufly_ai_vpft/SelfTest/GA/GA_8_13.png',
			'https://oss.uflycloud.com/ufly_ai_vpft/SelfTest/GA/GA_8_14.png',
			'https://oss.uflycloud.com/ufly_ai_vpft/SelfTest/GA/GA_8_15.png',
			'https://oss.uflycloud.com/ufly_ai_vpft/SelfTest/GA/GA_8_16.png',
			'https://oss.uflycloud.com/ufly_ai_vpft/SelfTest/GA/GA_8_17.png',
			'https://oss.uflycloud.com/ufly_ai_vpft/SelfTest/GA/GA_8_18.png',
			'https://oss.uflycloud.com/ufly_ai_vpft/SelfTest/GA/GA_8_19.png',
		],
        //过程数据
        progressData:[],
        result:null
	},
	getters:{
        
	},
}